import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SocialNetworkMessageFilesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { UtilityService } from 'src/app/core/services/utility.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-medias-form',
    templateUrl: './medias-form.component.html',
    styleUrls: ['./medias-form.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class MediasFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  mediaTitle: string;
  file: any;
  imageUrl: string;
  protected currentService = inject(SocialNetworkMessageFilesService);

  //#endregion

  constructor(
    public UtilityService: UtilityService,
    private dialogRef: MatDialogRef<MediasFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.medias);
    }
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      mediaTitle: new FormControl('', Validators.required),
      file: new FormControl('', Validators.required),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: any) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .socialNetworkMessageFilesCreatePost({
        body: { File: this.file, Title: this.mediaTitle },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.unSubs();
    this.dialogRef.close(true);
  }

  //#endregion

  //#region file

  getFile(file) {
    try {
      if (!file) {
        this.imageUrl = '';
        return;
      }
      this.file = file;

      this.onFileChanged(file);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.medias);
    }
  }

  onFileChanged(file: any) {
    try {
      if (file && file) {
        this.form.controls['file'].setErrors(null);
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageUrl = event.target.result;
        };
        reader.readAsDataURL(file);
      }
      this.handleFileSelect(event);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.medias);
    }
  }

  handleFileSelect(evt) {
    try {
      const files = evt.target.files;
      const file = files[0];

      if (files && file) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.medias);
    }
  }

  //#endregion
}
